<template>
  <div 
    v-show="visi"
    class="use-cookie">
    <div class="content">
      <h1>COOKIE 横幅提示</h1>
      <p>我们非常注重您的隐私。 我们在运行网站时使用必要的cookie，在您的浏览过程中为您保驾护航。经您同意后，我们和我们的合作伙伴还会使用cookie跟踪您的在线活动，根据您的兴趣和偏好为您推荐相应内容和广告，以及社交媒体相关功能。</p>
      <div class="button">
        <el-button
          type="primary"
          @click="acceptCookie()">
          明白
        </el-button>
      </div>
      <a 
        class="close-btn"
        @click="visi = false">
        <i class="el-icon-close" />
      </a>
    </div>
  </div>
</template>

<script>
const key = 'ACEEPT_COOKIE'
export default {
  data () {
    return {
      visi: localStorage.getItem(key) ? false : true
    }
  },
  methods: {
    acceptCookie(){
      localStorage.setItem(key, 'true')
      this.visi = false
    }
  }
}
</script>

<style lang="scss" scoped>
.use-cookie{
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 240px;
  background-color: #fff;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 2px rgba(0,0,0,.1);
  .content{
    width: 600px;
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    padding-top: 8px;
    position: relative;
    h1{
      font-size: 18px;
      font-weight: bold;
    }
    p{
      text-indent: 2em;
      line-height: 1.4em;
      a{
        text-decoration: underline;
        color: $theme-color;
      }
    }
    .button{
      display: flex;
      justify-content: flex-end;
      column-gap: 40px;
      .el-button{
        & + .el-button{
          margin-left: 0;
        }
        &.el-button--text{
          color: $text1;
          font-weight: bold;
          font-size: 16px;
          &:hover{
            color: $text2;
          }
        }
        &.el-button--primary{
          border-radius: 0;
          padding: 12px 25px;
        }
      }
    }
    .close-btn{
      position: absolute;
      right: 0px;
      top: 0px;
      font-size: 30px;
      font-weight: bold;
      color: $text2;
      &:hover{
        color: $text1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/UseCookie.vue